import React from 'react'
import styled from 'styled-components'
import { useModal } from '../index'
import { IconClose } from '../atoms/Icons'
import { color, spacing, fontSize } from '../theme'

const RoundButton = styled.button`
   background: ${color.primary};
   color: ${color.white};
   font-size: ${fontSize.xs};
   font-weight: bold;
   display: inline-flex;
   width: ${fontSize.sm};
   height: ${fontSize.sm};
   border: none;
   border-radius: 50%;
   position: relative;
   align-items: center;
   justify-content: center;
   margin-left: ${spacing.s};
   span {
      margin: 0;
   }
`

const ModalHeader = styled.div`
   display: flex;
   justify-content: flex-end;
   width: 100%;
`

const IconButton = styled.button`
   display: inline-flex;
   align-items: center;
   cursor: pointer;
   color: ${color.greyLight};
   transition: color 0.1s linear;
   border: 0;
   background: none;
   padding: 0;

   &:hover {
      color: inherit;
      transition: color 0.0875s ease-out;
   }

   span {
      margin-left: ${spacing.xs};
   }
   svg {
      width: 1.1em;
      height: 1.1em;

      &:not(:only-child) {
         margin-left: calc(${spacing.xs} * 1.5);
      }

      * {
         fill: currentColor;
      }
   }
`

export const InfoButton = ({ ...props }) => (
   <RoundButton type="button" {...props}>
      <span>?</span>
   </RoundButton>
)

export const InfoButtonModal = ({ children, ...props }) => {
   const [InfoModal, setIsOpen] = useModal()

   return (
      <>
         <RoundButton
            type="button"
            title={'More info'}
            onClick={() => setIsOpen(true)}
            {...props}
         >
            <span>?</span>
         </RoundButton>
         <InfoModal>
            <ModalHeader>
               <IconButton type="button" onClick={() => setIsOpen(false)}>
                  <IconClose width={'18px'} height={'18px'} />
                  <span> Close</span>
               </IconButton>
            </ModalHeader>
            {children}
         </InfoModal>
      </>
   )
}
